export const DB_VERSION = 37;
export const MAX_STACK_SUCCESS_SIZE = 50;
export const FILE_SIGNATURE_NAME = 'signature.png';
